import template from './calendarInlinePaginator.html';
import controller from './calendarInlinePaginator.controller';
import './calendarInlinePaginator.scss';

let calendarInlinePaginatorComponent = {
  restrict: 'E',
  bindings: {
    date: '<',
    id: '<',
    nextPage: '&',
    prevPage: '&',
    onYearPaginationChanges: '&'
  },
  template,
  controller
};

export default calendarInlinePaginatorComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/calendarInlineComponent/calendarInlinePaginator/calendarInlinePaginator.component.js